import { useCallback } from "react";

export default function useTabNavigation({ state, updateState, countVisibleTabs, templateRef, executeFunctionByUid, validateConnection }) {
  const updatePhones = useCallback(() => {
    updateState((prev) => {
      const numVisible = countVisibleTabs(templateRef.current?.tabs);
      return {
        refreshCounter: prev.refreshCounter + 1,
        numOfVisibleTabs: numVisible,
        isNextTabVisible: prev.selectedTabIndex < numVisible - 1,
      };
    });
  }, [updateState, countVisibleTabs, templateRef]);

  const HideNextTab = useCallback(() => {
    const numVisible = countVisibleTabs(templateRef.current?.tabs);
    if (state.selectedTabIndex === numVisible - 1) {
      updateState({ isNextTabVisible: false });
    } else {
      updateState({ isNextTabVisible: true });
    }
  }, [state.selectedTabIndex, updateState, countVisibleTabs, templateRef]);

  const NextTab = useCallback(() => {
    executeFunctionByUid("NextTab");
    const top = document.getElementById("top");
    if (top) top.scrollIntoView();
    updateState({ selectedTabIndex: state.selectedTabIndex + 1 });
    HideNextTab();
    validateConnection();
  }, [state.selectedTabIndex, updateState, executeFunctionByUid, HideNextTab, validateConnection]);

  const PrevTab = useCallback(() => {
    const top = document.getElementById("top");
    if (top) top.scrollIntoView();
    updateState({ selectedTabIndex: state.selectedTabIndex - 1 });
    HideNextTab();
  }, [state.selectedTabIndex, updateState, HideNextTab]);

  return { updatePhones, HideNextTab, NextTab, PrevTab };
}
